var InvsectionsContent = []
var generalInvCount = 0
var btnCount = 0
var btnArray = []
var doc
$(document).ready(function () {
  if ($(document).width() < 767) {
    $('#inv_customize_button').remove()
  }
  window.jsPDF = window.jspdf.jsPDF;

  doc = new jsPDF();

  document.getElementById('color-primario1')?.addEventListener('change', (e) => {
    $('#invitaciones-section').append(`<style>
    #invitaciones-section .pc-text{
      color:${e.target.value}!important;
    }
    #invitaciones-section .pc-border{
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-btn:hover{
      color:${e.target.value}!important;
    }
    #invitaciones-section .pc-border-hover:hover{
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-input{
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-bg{
      background-color:${e.target.value}!important;
    }
    #invitaciones-section .sc-btn{
      color:${e.target.value}!important;
    }
    #invitaciones-section .sc-btn:hover{
      background-color:${e.target.value}!important;
    }
    #invitaciones-section .tc-btn{
      color:${e.target.value}!important;
    }
    #invitaciones-section .pc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    #invitaciones-section .pc-underline-btn:hover{
      border-bottom-color: ${e.target.value}99!important;
      color: ${e.target.value}99!important;
    }
    #invitaciones-section .sc-underline-btn:hover{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    #invitaciones-section .tc-pc-btn:hover{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-to-transparent-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-to-transparent-btn:hover{
      background-color:transparent!important;
      border-color:${e.target.value}!important;
      color:${e.target.value}!important;
    }
    </style`)
  })
  document.getElementById('color-secundario1')?.addEventListener('change', (e) => {
    $('#invitaciones-section').append(`<style>
    #invitaciones-section .sc-text{
      color:${e.target.value}!important;
    }
    #invitaciones-section .sc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .sc-btn:hover{
      border-color:${e.target.value}!important;
      color:${e.target.value}!important;
    }
    #invitaciones-section .sc-bg{
      background-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-btn{
      color:${e.target.value}!important;
    }
    #invitaciones-section .sc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    #invitaciones-section .tc-pc-btn{
      color: ${e.target.value}!important;
    }
    #invitaciones-section .tc-pc-btn:hover{
      color:${e.target.value}!important;
    }
    #invitaciones-section .pc-to-transparent-btn{
      color:${e.target.value}!important;
    }
    </style`)
  })
  document.getElementById('color-terciario1')?.addEventListener('change', (e) => {
    $('#invitaciones-section').append(`<style>
    #invitaciones-section .pc-btn:hover{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .pc-input:focus{
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .tc-text{
      color:${e.target.value}!important;
    }
    #invitaciones-section .tc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .tc-btn:hover{
      background-color:transparent!important;
      border-color:${e.target.value}!important;
      color:${e.target.value}!important;
    }
    #invitaciones-section .tc-bg{
      background-color:${e.target.value}!important;
    }
    #invitaciones-section .tc-underline-btn{
      border-bottom-color: ${e.target.value}!important;
      color: ${e.target.value}!important;
    }
    #invitaciones-section .tc-underline-btn:hover{
      border-bottom-color: ${e.target.value}99!important;
      color: ${e.target.value}99!important;
    }
    #invitaciones-section .tc-pc-btn{
      background-color:${e.target.value}!important;
      border-color:${e.target.value}!important;
    }
    #invitaciones-section .tc-sc-btn {
      background-color: ${e.target.value} !important;
    }
    </style`)
  })


  const select3 = document.getElementById("font-selector-3")
  const select4 = document.getElementById("font-selector-4")

  fetch("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBk5d60ANsCB9T8zbtsZqghVStGielL5JI").then(
    (response) => response.json()
  ).then(
    (data) => {
      data.items.map((item) => {
        const option = document.createElement("option")
        option.value = item.family
        option.innerHTML = item.family
        const option2 = document.createElement("option")
        option2.value = item.family
        option2.innerHTML = item.family
        if (select3) {
          select3.appendChild(option)
        }
        if (select4) {
          select4.appendChild(option2)
        }
      })
    }
  )

  select3?.addEventListener("change", () => {
    let apiUrl = [];
    apiUrl.push('https://fonts.googleapis.com/css?family=')
    apiUrl.push(select3.value.replace(/ /g, '+'))
    let url = apiUrl.join('')
    let fontStyle = `#invitaciones-section h1,
  #invitaciones-section h2,
  #invitaciones-section h3,
  #invitaciones-section h4,
  #invitaciones-section h5,
  #invitaciones-section h6 {
    font-family: '${select3.value}', sans-serif !important;}`
    if (!document.getElementById("googleFont")) {
      let headLink = document.createElement('link')
      headLink.rel = "stylesheet"
      headLink.href = url
      headLink.id = "googleFont"
      document.body.appendChild(headLink)
    } else {
      let currentHeadLink = document.getElementById("googleFont")
      currentHeadLink.href = url
    }
    if (!document.getElementById("customStyle")) {

      let headStyle = document.createElement("style")
      headStyle.innerText = fontStyle
      headStyle.id = "customStyle"
      document.body.appendChild(headStyle)
    } else {
      let customStyle = document.getElementById("customStyle")
      console.log(customStyle)
      customStyle.innerHTML = fontStyle
    }
  })

  select4?.addEventListener("change", () => {
    let apiUrl = [];
    apiUrl.push('https://fonts.googleapis.com/css?family=')
    apiUrl.push(select4.value.replace(/ /g, '+'))
    let url = apiUrl.join('')
    let fontStyle = `#invitaciones-section div,
    #invitaciones-section a {
    font-family: '${select4.value}', sans-serif !important;}`
    if (!document.getElementById("googleFont2")) {
      let headLink = document.createElement('link')
      headLink.rel = "stylesheet"
      headLink.href = url
      headLink.id = "googleFont2"
      document.body.appendChild(headLink)
    } else {
      let currentHeadLink = document.getElementById("googleFont2")
      currentHeadLink.href = url
    }
    if (!document.getElementById("customStyle2")) {

      let headStyle = document.createElement("style")
      headStyle.innerText = fontStyle
      headStyle.id = "customStyle2"
      document.body.appendChild(headStyle)
    } else {
      let customStyle = document.getElementById("customStyle2")
      console.log(customStyle)
      customStyle.innerHTML = fontStyle
    }
  })



})

function showCustomizeInvMenu(val) {
  if (val == 0) {
    $('#inv_customize_button').animate({
      left: '-30%'
    });
    $('#inv_customize_menu').animate({
      width: '34vw'
    });
  }
  else {
    $('#inv_customize_button').animate({
      left: '12%'
    });
    $('#inv_customize_menu').animate({
      width: '0%'
    });
  }
}

function showInvSectionsMenu(val) {
  if ($('#' + val).is(":visible")) {
    $('#' + val).slideUp()
  }
  else {
    $('#' + val).slideDown()
  }
}

function showInvSectionFields(nmb) {
  if ($('#' + nmb).is(":visible")) {
    $('#' + nmb).slideUp()
  }
  else {
    $('#' + nmb).slideDown()
  }
}

function toggleMenuInvitation(nmb) {
  if ($('#menuInvitation-' + nmb).is(":visible")) {
    $('#menuInvitation-' + nmb).slideUp()
  }
  else {
    $('#menuInvitation-' + nmb).slideDown()
    for (let i = 0; i < 99; i++) {
      $('#invitation-' + i).addClass('d-none')
      if (i == nmb) {
        $('#invitation-' + i).removeClass('d-none')
      }
    }
  }
}

function deleteInvitation(nmb) {
  for (let i = 0; i < InvsectionsContent.length; i++) {
    if (InvsectionsContent[i].id == nmb) {
      var element = InvsectionsContent[i]
    }
  }
  $('#inv-gen-dd-' + nmb).remove()
  $('#invitation-' + nmb).remove()
  InvsectionsContent.splice(InvsectionsContent.indexOf(element), 1);
}


function createInvEventItem(nmb, vestimenta, fecha, nombre, descripcion, link) {
  if ($('#design_template').attr('data') == 'Template 1') {
    $('#invevents-0').append(`<div
    id="invEvent-${nmb}-0"
    eventid="${nmb + 1}"
    class="cont eventElement invCanBeDeleted">
    <div class="flex ver cen small-gap">
      <div id="inv-title-val-${nmb}" class="big-par sc-text">${nombre}</div>
      <div id="inv-description-val-${nmb}" class="body-txt sc-text">${descripcion}</div>
      <div class="body-txt sc-text">Vestimenta: <span id="inv-outfit-val-${nmb}">${vestimenta}</span>
      </div>
      <div id="inv-date-val-${nmb}" class="body-txt sc-text classdate">${fecha}</div>
      <a
        href="${link}"
        target="_blank"
        id="inv-googleLink-val-${nmb}"
        class="btn sec-btn small-btn w-button sc-btn">Link a Google Maps</a>
    </div>
  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 2') {
    $('#invevents-0').append(`<div
    id="invEvent-${nmb}-0"
    eventid="${nmb + 1}"
    class="cont eventElement invCanBeDeleted">
    <div class="flex ver cen small-gap">
      <h3 id="inv-title-val-${nmb}" class="pc-text">${nombre}</h3>
      <p id="inv-description-val-${nmb}" class="body-txt pc-text">${descripcion}</p>
      <p class="body-txt pc-text">Vestimenta: <span id="inv-outfit-val-${nmb}">${vestimenta}</span>
      </p>
      <p id="inv-date-val-${nmb}" class="body-txt pc-text classdate">${fecha}</p>
      <a
        href="${link}"
        target="_blank"
        id="inv-googleLink-val-${nmb}"
        class="btn sec-btn small-btn w-button pc-to-transparent-btn">Link a Google Maps</a>
    </div>
  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 3') {
    $('#invevents-0').append(`<div
    id="invEvent-${nmb}-0"
    eventid="${nmb + 1}"
    class="cont eventElement invCanBeDeleted">
    <div class="flex ver left small-gap">
      <h3 id="inv-title-val-${nmb}" class="pc-text">${nombre}</h3>
      <div id="inv-description-val-${nmb}" class="body-txt pc-text">${descripcion}</div>
      <div class="body-txt pc-text">Vestimenta: <span id="inv-outfit-val-${nmb}">${vestimenta}</span></div>
      <div id="inv-date-val-${nmb}" class="body-txt pc-text classdate">
        ${fecha}
      </div>
      <a
        href="${link}"
        target="_blank"
        id="inv-googleLink-val-${nmb}"
        class="btn prim-btn w-button pc-text">Ver en Google Maps</a>
    </div>
  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 4') {
    $('#invevents-0').append(`<div class="cont eventElement invCanBeDeleted"
    id="invEvent-${nmb}-0"
    eventid="${nmb + 1}">
    <div class="grid flex ver cen mid gap">
      <div class="cont">
        <div class="flex ver cen small-gap">
          <h3 id="inv-title-val-${nmb}" class="big-par sc-text">${nombre}</h3>
          <div id="inv-description-val-${nmb}" class="body-txt sc-text">${descripcion}</div>
          <div class="body-txt sc-text">Vestimenta: <span id="inv-outfit-val-${nmb}">${vestimenta}</span></div>
          <div id="inv-date-val-${nmb}" class="body-txt sc-text classdate">
            ${fecha}
          </div>
          <a
            href="${link}"
            target="_blank"
            id="inv-googleLink-val-${nmb}"
            class="btn sec-btn w-button tc-underline-btn">Ver en Google Maps</a>
        </div>
      </div>
    </div>
  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 5') {
    $('#invevents-0').append(`<div
    id="invEvent-${nmb}-0"
    eventid="${nmb + 1}"
    class="cont eventElement invCanBeDeleted">
    <div id="w-node-f11c4dfa-20dc-9d00-7b09-418a0206905c-c04e3c30" class="cont">
      <div class="pad small-pad no-left-pad">
        <div class="flex ver left gap">
          <div class="cont">
            <div class="flex ver left small-gap">
              <h2 id="inv-title-val-${nmb}" class="white-txt sc-text">${nombre}</h2>
              <div id="inv-description-val-${nmb}" class="small-par sc-text">${descripcion}</div>
              <div id="inv-date-val-${nmb}" class="med-par sc-text">${fecha}</div>
            </div>
          </div>
          <div class="cont">
            <div class="flex ver left mini-gap">
              <div class="med-par">Vestimenta: <span id="inv-outfit-val-${nmb}">${vestimenta}</span></div>
            </div>
          </div>
          <a href="${link}" id="inv-googleLink-val-${nmb}" class="btn alt-btn white-txt w-button">Link a Google Maps</a>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="separator light-separator sc-bg"></div>
    </div>
  </div>`)
  }
}


function addEventoBlock(nombre = "Nuevo Evento", descripcion = "", fecha = "", vestimenta = "", ubicacion = "", link = "", requiere = "", ubiId = "", graphId = "") {
  var requiereContent
  var fecha1 = fecha
  var fecha2 = fecha
  if (fecha != "") {
    fecha = formatearFecha(fecha.split('T')[0]) + 'T' + fecha.split('T')[1]
  }
  if (fecha1.length == 25) {
    var date = fecha1
    var hour = (parseInt(date.substring(11, 13)) - 6)
    var formatedDate = date.substring(0, 10)
    if (hour < 0) {
      hour = 24 + hour
      formatedDate = restarUnDia(date.substring(0, 10))
    }
    if (hour > 24) {
      hour = hour - 24
      formatedDate = sumarUnDia(date.substring(0, 10))
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    formatedDate = formatedDate + 'T'
    date = formatedDate + hour + date.substring(13)
    if (date.length < 19) {
      date = date + ':00'
    }
    fecha1 = date
  }
  createInvEventItem(invEventCount, vestimenta, fecha, nombre, descripcion, link)
  if (requiere == "true") {
    requiereContent = `<label class="w-checkbox check w--redirected-checked" style="font-family: Inconsolata, monospace!important"><input type="checkbox" id="inv-require-${invEventCount}" checked name="checkbox" data-name="Checkbox" class="w-checkbox-input check-btn"><span class="check-label w-form-label" for="checkbox">¿Quieres que Zépika se encargue de las confirmaciones para este evento?</span></label>`
  }
  else {
    requiereContent = `<label class="w-checkbox check" style="font-family: Inconsolata, monospace!important"><input type="checkbox" id="inv-require-${invEventCount}" name="checkbox" data-name="Checkbox" class="w-checkbox-input check-btn"><span class="check-label w-form-label" for="checkbox">¿Quieres que Zépika se encargue de las confirmaciones para este evento?</span></label>`
  }
  $('#invEventContainer').append(`<div id="dd-cevent_${invEventCount}" parent="${invEventCount}" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
            <div onclick="showInvSectionFields('inv-event-${invEventCount}')" class="cust-dd-tog sub-dd w-dropdown-toggle">
              <div id="dd-Event-Title-${invEventCount}" style="font-family: Inconsolata, monospace!important">${nombre}</div>
              <div class="dd-icon w-icon-dropdown-toggle"></div>
            </div>
            <nav id="inv-event-${invEventCount}" class="cust-dd-drawer w-dropdown-list">
            <div class="flex ver gap">
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Nombre del Evento</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  value="${nombre}"
                  name="title"
                  data-name="Field"
                  placeholder="Título"
                  id="inv-title-${invEventCount}"
                  required=""
                >
              </div>
              <div class="cust-field-wrap">
                <label class="field-label">Descripción</label><textarea
                  id="inv-description-${invEventCount}"
                  name="field-3"
                  maxlength="5000"
                  value="${descripcion}"
                  data-name="Field 3"
                  placeholder="Descripción"
                  class="cust-input textarea w-input"
                >${descripcion}</textarea>
              </div>
              <div class="cust-field-wrap">
                <label class="field-label">Fecha</label>
                <input type="datetime-local" 
                class="input w-input" maxlength="256" 
                name="field-5" 
                data-name="Field 5" 
                value="${fecha1.replace('+00:00', '')}"
                placeholder="Fecha y Hora" 
                id="inv-date-${invEventCount}"
                style="font-family: Inconsolata, monospace!important"
                >
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Código de vestimenta</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  value="${vestimenta}"
                  data-name="Field"
                  placeholder="Código de Vestimenta"
                  id="inv-outfit-${invEventCount}"
                  required=""
                >
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Nombre de la ubicación</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  value="${ubicacion}"
                  data-name="Field"
                  placeholder="Nombre de la ubicación"
                  id="inv-place-${invEventCount}"
                >
              </div>
              <div class="cust-field-wrap">
                <label for="field" class="field-label">Link de Google Maps</label
                ><input
                  type="text"
                  class="cust-input w-input"
                  maxlength="256"
                  name="title"
                  value="${link}"
                  data-name="Field"
                  placeholder="Link de Google Maps"
                  id="inv-googleLink-${invEventCount}"
                >
              </div>
              <div class="cust-field-wrap">
                ${requiereContent}
              </div>
              <a href="#" onclick="deleteEventDD(${invEventCount})" class="cust-del w-inline-block"
                ><img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/trash-01.svg?v=79518031219586732181678131632" alt="" class="icon">
                <div style="color:#e73535; font-family: Inconsolata, monospace!important" >Eliminar Evento</div>
              </a>
              </div>
            </nav>
          </div>`)
  InvEventsContent.push({
    "id": invEventCount,
    "graphId": graphId,
    "fields": [
      { "key": "nombre_del_evento", "value": nombre },
      { "key": "fecha_y_hora", "value": fecha2 },
      { "key": "descripcion", "value": descripcion },
      { "key": "codigo_de_vestimenta", "value": vestimenta },
      { "key": "requiere_invitacion", "value": requiere },
      { "key": "ubicacion", "value": ubiId }
    ],
    "ubicacion_fields": [
      { "key": "nombre_de_ubicacion", "value": ubicacion },
      { "key": "link_a_google_maps", "value": link }
    ]
  })
  flatpickr("#inv-date-" + invEventCount, { enableTime: true, minDate: "today" });
  invInitEvent(invEventCount)
  invEventCount++
}

function deleteEventDD(nmb) {
  for (let i = 0; i < InvEventsContent.length; i++) {
    if (InvEventsContent[i].id == nmb) {
      InvEventsContent.splice(i, 1)
    }
  }
  $('#dd-cevent_' + nmb).remove()
  $('#invEvent-' + nmb + '-0').remove()
}

function invInitEvent(nmb) {
  document.getElementById('inv-title-' + nmb).addEventListener('change', async (e) => {
    $('#inv-title-val-' + nmb).text(e.target.value)
    $('#dd-Event-Title-' + nmb).text(e.target.value)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].fields.length; j++) {
          if (InvEventsContent[i].fields[j].key == "nombre_del_evento") {
            InvEventsContent[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-date-' + nmb).addEventListener('change', async (e) => {
    var fecha = e.target.value
    if (fecha != "") {
      if (fecha.includes('T')) {
        fecha = formatearFecha(fecha.split('T')[0]) + ' | ' + fecha.split('T')[1]
      }
      else {
        fecha = formatearFecha(fecha.split(' ')[0]) + ' | ' + fecha.split(' ')[1]
      }
    }
    $('#inv-date-val-' + nmb).text(fecha)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].fields.length; j++) {
          if (InvEventsContent[i].fields[j].key == "fecha_y_hora") {
            var date = e.target.value.replace('T', ' ')
            date = date.replace(' ', 'T')
            var hour = (parseInt(date.substring(11, 13)) + 6)
            var formatedDate = date.substring(0, 10)
            if (hour < 0) {
              hour = 24 + hour
              formatedDate = restarUnDia(date.substring(0, 10))
            }
            if (hour > 24) {
              hour = hour - 24
              formatedDate = sumarUnDia(date.substring(0, 10))
            }
            if (hour < 10) {
              hour = '0' + hour
            }
            formatedDate = formatedDate + 'T'
            date = formatedDate + hour + date.substring(13)
            if (date.length < 19) {
              date = date + ':00'
            }
            InvEventsContent[i].fields[j].value = date
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-description-' + nmb).addEventListener('change', async (e) => {
    $('#inv-description-val-' + nmb).text(e.target.value)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].fields.length; j++) {
          if (InvEventsContent[i].fields[j].key == "descripcion") {
            InvEventsContent[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-outfit-' + nmb).addEventListener('change', async (e) => {
    $('#inv-outfit-val-' + nmb).text(e.target.value)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].fields.length; j++) {
          if (InvEventsContent[i].fields[j].key == "codigo_de_vestimenta") {
            InvEventsContent[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-require-' + nmb).addEventListener('change', async (e) => {
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].fields.length; j++) {
          if (InvEventsContent[i].fields[j].key == "requiere_invitacion") {
            if (e.target.checked) {
              InvEventsContent[i].fields[j].value = "true"
            }
            else {
              InvEventsContent[i].fields[j].value = "false"
            }
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-place-' + nmb).addEventListener('change', async (e) => {
    //$('#inv-place-val-'+nmb).text(e.target.value)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].ubicacion_fields.length; j++) {
          if (InvEventsContent[i].ubicacion_fields[j].key == "nombre_de_ubicacion") {
            InvEventsContent[i].ubicacion_fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-googleLink-' + nmb).addEventListener('change', async (e) => {
    $('#inv-googleLink-val-' + nmb).attr('href', e.target.value)
    for (let i = 0; i < InvEventsContent.length; i++) {
      if (InvEventsContent[i].id == nmb) {
        for (let j = 0; j < InvEventsContent[i].ubicacion_fields.length; j++) {
          if (InvEventsContent[i].ubicacion_fields[j].key == "link_a_google_maps") {
            InvEventsContent[i].ubicacion_fields[j].value = e.target.value.replaceAll(' ', '')
            break
          }
        }
      }
    }
  })
}

function formatearFecha2(fecha) {
  const meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  const partes = fecha.split('-');
  const anio = partes[0];
  const mes = parseInt(partes[1], 10);
  const dia = parseInt(partes[2], 10);

  const fechaFormateada = `${dia} de ${meses[mes - 1]} de ${anio}`;

  return fechaFormateada;
}

function sanitizeInput(text) {
  //let text = $(selector).text();
  text = text.trim();
  text = text.replace(/^\n+|\n+$/g, '');
  text = text.trim();

  return text;
}


function initializeInvitation(nmb) {
  generalInvCount++
  const eventsVisible = $('#displayEvents' + nmb).text()
  InvsectionsContent.push(
    {
      "id": nmb,
      "type": "wedsite_invitaciones",
      "fields": [
        {
          "key": "imagen_de_invitacion",
          "value": ""
        },
        {
          "key": "imagen",
          "value": $('#foldImage' + nmb).attr('value')
        },
        {
          "key": "eventos",
          "value": JSON.parse(eventsVisible)
        },
        {
          "key": "footer_visible",
          "value": $('#footerVisible' + nmb).attr('value')
        },
        {
          "key": "events_visible",
          "value": $('#eventsVisible' + nmb).attr('value')
        },
        {
          "key": "main_visible",
          "value": $('#mainVisible' + nmb).attr('value')
        },
        {
          "key": "nombre_de_invitacion",
          "value": $('#inv-ndi-input-' + nmb).val()
        },
        {
          "key": "nombre_de_padre_1",
          "value": $('#invname1-' + nmb).text()
        },
        {
          "key": "nombre_de_madre_1",
          "value": $('#invname2-' + nmb).text()
        },
        {
          "key": "nombre_de_padre_2",
          "value": $('#invname3-' + nmb).text()
        },
        {
          "key": "nombre_de_madre_2",
          "value": $('#invname4-' + nmb).text()
        },
        {
          "key": "introduccion",
          "value": $('#invintro-' + nmb).text()
        },
        {
          "key": "texto_grande",
          "value": $('#invtitle-' + nmb).text()
        },
        {
          "key": "texto_chico",
          "value": $('#invdate-' + nmb).text()
        },
        {
          "key": "contenido",
          "value": $('#invcontent-' + nmb).text()
        },
        {
          "key": "texto_con_link",
          "value": $('#invtextLink-' + nmb).text()
        },
        {
          "key": "link",
          "value": $('#invtextLink-' + nmb).attr('href')
        },
        {
          "key": "texto_del_boton",
          "value": $('#invbtn-' + nmb).text()
        },
        {
          "key": "link_del_boton",
          "value": $('#invbtn-' + nmb).attr('href')
        },
        {
          "key": "numero_de_boletos",
          "value": $('.invBoletosQty').first().text()
        },
        {
          "key": "titulo_de_eventos",
          "value": $('#inveventsTitle-' + nmb).text()
        },
        {
          "key": "texto_superior",
          "value": $('#invsuperior-' + nmb).text()
        },
        {
          "key": "footer_texto_grande",
          "value": $('#invfooterTitle-' + nmb).text()
        },
        {
          "key": "footer_contenido",
          "value": $('#invfooterContent-' + nmb).text()
        },
        {
          "key": "footer_texto_del_boton",
          "value": $('#invfooterLink-' + nmb).text()
        },
        {
          "key": "footer_link_del_boton",
          "value": $('#invfooterLink-' + nmb).attr('href')
        },
        {
          "key": "botones",
          "value": btnArray
        },
        {
          "key": "ultimo_texto",
          "value": $('#invlastText-' + nmb).text()
        }]
    })
  let dad1Input = $('#invname1-' + nmb).text()
  let invIntroInput = $('#invintro-' + nmb).text()

  $('#inv-dad1-input-' + nmb).val($('#invname1-' + nmb).text().trim())
  $('#inv-mom1-input-' + nmb).val($('#invname2-' + nmb).text().trim())
  $('#inv-dad2-input-' + nmb).val($('#invname3-' + nmb).text().trim())
  $('#inv-mom2-input-' + nmb).val($('#invname4-' + nmb).text().trim())
  $('#inv-intro-input-' + nmb).val($('#invintro-' + nmb).text().trim())
  $('#inv-title-input-' + nmb).val($('#invtitle-' + nmb).text().trim())
  $('#inv-date-input-' + nmb).val($('#invdate-' + nmb).text().trim())
  if ($('#inv-content-input-' + nmb).length > 0) {
    $('#inv-content-input-' + nmb).val($('#invcontent-' + nmb).text().trim())
  } else {
    $('#inv-content-input-' + nmb).val($('Contenido'))
  }
  $('#inv-Textname-input-' + nmb).val($('#invtextLink-' + nmb).text().trim())
  $('#inv-Textlink-input-' + nmb).val($('#invtextLink-' + nmb).attr('href'))
  $('#inv-ubication-name-input-' + nmb).val($('#invbtn-' + nmb).text().trim())
  $('#inv-ubication-link-input-' + nmb).val($('#invbtn-' + nmb).attr('href'))
  $('#inv-events-title-' + nmb).val($('#inveventsTitle-' + nmb).text().trim())
  if ($('#inv-superior-input-' + nmb).length > 0) {
    $('#inv-superior-input-' + nmb).val($('#invsuperior-' + nmb).text().trim())
  } else {
    $('#inv-superior-input-' + nmb).val($("Texto superior"))
  }
  $('#inv-footer-big-input-' + nmb).val($('#invfooterTitle-' + nmb).text().trim())
  $('#inv-footer-content-input-' + nmb).val($('#invfooterContent-' + nmb).text().trim())
  $('#inv-footer-last-input-' + nmb).val($('#invlastText--' + nmb).text().trim())
  $('#inv-footer-name-input-' + nmb).val($('#invfooterLink-' + nmb).text().trim())
  $('#inv-footer-link-input-' + nmb).val($('#invfooterLink-' + nmb).attr('href'))
  $('#tickets-qty-input').val($('.invBoletosQty').first().text())



  if ($('#inv-events-title-' + nmb).length > 0) {
    document.getElementById('inv-events-title-' + nmb).addEventListener('change', async (e) => {
      $('#inveventsTitle-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "titulo_de_eventos") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-ndi-input-' + nmb).length > 0) {
    document.getElementById('inv-ndi-input-' + nmb).addEventListener('change', async (e) => {
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "nombre_de_invitacion") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#tickets-qty-input').length > 0) {
    document.getElementById('tickets-qty-input').addEventListener('change', async (e) => {
      $('.invBoletosQty').text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == 0) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "numero_de_boletos") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if (document.getElementById('inv-dad1-input-' + nmb)) {
    document.getElementById('inv-dad1-input-' + nmb).addEventListener('change', async (e) => {
      $('#invname1-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "nombre_de_padre_1") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if (document.getElementById('inv-mom1-input-' + nmb)) {
    document.getElementById('inv-mom1-input-' + nmb).addEventListener('change', async (e) => {
      $('#invname2-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "nombre_de_madre_1") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if (document.getElementById('inv-dad2-input-' + nmb)) {
    document.getElementById('inv-dad2-input-' + nmb).addEventListener('change', async (e) => {
      $('#invname3-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "nombre_de_padre_2") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if (document.getElementById('inv-mom2-input-' + nmb)) {
    document.getElementById('inv-mom2-input-' + nmb).addEventListener('change', async (e) => {
      $('#invname4-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "nombre_de_madre_2") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-intro-input-' + nmb).length > 0) {
    document.getElementById('inv-intro-input-' + nmb).addEventListener('change', async (e) => {
      $('#invintro-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "introduccion") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-title-input-' + nmb).length > 0) {
    document.getElementById('inv-title-input-' + nmb).addEventListener('change', async (e) => {
      $('#invtitle-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "texto_grande") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-date-input-' + nmb).length > 0) {
    document.getElementById('inv-date-input-' + nmb).addEventListener('change', async (e) => {
      $('#invdate-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "texto_chico") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-content-input-' + nmb).length > 0) {
    document.getElementById('inv-content-input-' + nmb).addEventListener('change', async (e) => {
      var match = /\r|\n/.exec(e.target.value);
      if (match == null) {
        $('#invcontent-' + nmb).html(e.target.value)
      }
      else {
        $('#invcontent-' + nmb).html(match['input'].replaceAll('\n', '<br>'))
      }
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "contenido") {
              if (match == null) {
                InvsectionsContent[i].fields[j].value = e.target.value
              }
              else {
                InvsectionsContent[i].fields[j].value = match['input'].replaceAll('\n', '<br>')
              }
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-Textname-input-' + nmb).length > 0) {
    document.getElementById('inv-Textname-input-' + nmb).addEventListener('change', async (e) => {
      $('#invtextLink-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "texto_con_link") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-Textlink-input-' + nmb).length > 0) {
    document.getElementById('inv-Textlink-input-' + nmb).addEventListener('change', async (e) => {
      var val = e.target.value
      if (!e.target.value.includes('http')) {
        val = 'https://' + e.target.value
      }
      val = val.replaceAll(' ', '')
      if (val == 'https://') {
        val = ''
      }
      $('#invtextLink-' + nmb).attr('href', val)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "link") {
              InvsectionsContent[i].fields[j].value = val
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-ubication-name-input-' + nmb).length > 0) {
    document.getElementById('inv-ubication-name-input-' + nmb).addEventListener('change', async (e) => {
      $('#invbtn-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "texto_del_boton") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-ubication-link-input-' + nmb).length > 0) {
    document.getElementById('inv-ubication-link-input-' + nmb).addEventListener('change', async (e) => {
      $('#invbtn-' + nmb).attr('href', e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "link_del_boton") {
              InvsectionsContent[i].fields[j].value = e.target.value.replaceAll(' ', '')
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-superior-input-' + nmb).length > 0) {
    document.getElementById('inv-superior-input-' + nmb).addEventListener('change', async (e) => {
      $('#invsuperior-' + nmb).text(e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "texto_superior") {
              InvsectionsContent[i].fields[j].value = e.target.value
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-image-input-' + nmb).length > 0) {
    document.getElementById('inv-image-input-' + nmb).addEventListener('change', async (event) => {
      var previewImage = document.getElementById('invimg-' + nmb)
      var file = event.target.files[0];
      var fileId = await getFileId(file)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "imagen") {
              InvsectionsContent[i].fields[j].value = fileId
              break
            }
          }
        }
      }
      var reader = new FileReader();

      reader.onload = (readerEvent) => {
        var image = new Image();
        image.src = readerEvent.target.result;
        previewImage.src = image.src;
      };

      reader.readAsDataURL(file);
    });
  }
  document.getElementById('inv-footer-big-input-' + nmb).addEventListener('change', async (e) => {
    $('#invfooterTitle-' + nmb).text(e.target.value)
    for (let i = 0; i < InvsectionsContent.length; i++) {
      if (InvsectionsContent[i].id == nmb) {
        for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
          if (InvsectionsContent[i].fields[j].key == "footer_texto_grande") {
            InvsectionsContent[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-footer-name-input-' + nmb).addEventListener('change', async (e) => {
    $('#invfooterLink-' + nmb).text(e.target.value)
    for (let i = 0; i < InvsectionsContent.length; i++) {
      if (InvsectionsContent[i].id == nmb) {
        for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
          if (InvsectionsContent[i].fields[j].key == "footer_texto_del_boton") {
            InvsectionsContent[i].fields[j].value = e.target.value
            break
          }
        }
      }
    }
  })
  document.getElementById('inv-footer-content-input-' + nmb).addEventListener('change', async (e) => {
    var match = /\r|\n/.exec(e.target.value);
    if (match == null) {
      $('#invfooterContent-' + nmb).html(e.target.value)
    }
    else {
      $('#invfooterContent-' + nmb).html(match['input'].replaceAll('\n', '<br>'))
    }
    for (let i = 0; i < InvsectionsContent.length; i++) {
      if (InvsectionsContent[i].id == nmb) {
        for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
          if (InvsectionsContent[i].fields[j].key == "footer_contenido") {
            InvsectionsContent[i].fields[j].value = e.target.value
            if (match == null) {
              InvsectionsContent[i].fields[j].value = e.target.value
            }
            else {
              InvsectionsContent[i].fields[j].value = match['input'].replaceAll('\n', '<br>')
            }
            break
          }
        }
      }
    }
  })
  if ($('#inv-footer-last-input-' + nmb).length > 0) {
    document.getElementById('inv-footer-last-input-' + nmb).addEventListener('change', async (e) => {
      var match = /\r|\n/.exec(e.target.value);
      if (match == null) {
        $('#invlastText-' + nmb).html(e.target.value)
      }
      else {
        $('#invlastText-' + nmb).html(match['input'].replaceAll('\n', '<br>'))
      }
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "ultimo_texto") {
              InvsectionsContent[i].fields[j].value = e.target.value
              if (match == null) {
                InvsectionsContent[i].fields[j].value = e.target.value
              }
              else {
                InvsectionsContent[i].fields[j].value = match['input'].replaceAll('\n', '<br>')
              }
              break
            }
          }
        }
      }
    })
  }
  if ($('#inv-footer-link-input-' + nmb).length > 0) {
    document.getElementById('inv-footer-link-input-' + nmb).addEventListener('change', async (e) => {
      $('#invfooterLink-' + nmb).attr('href', e.target.value)
      for (let i = 0; i < InvsectionsContent.length; i++) {
        if (InvsectionsContent[i].id == nmb) {
          for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
            if (InvsectionsContent[i].fields[j].key == "footer_link_del_boton") {
              InvsectionsContent[i].fields[j].value = e.target.value.replaceAll(' ', '')
              break
            }
          }
        }
      }
    })
  }
}

function showBtnFields(nmb) {
  if ($('#btn_section_' + nmb).is(':visible')) {
    $('#btn_section_' + nmb).slideUp()
  }
  else {
    $('#btn_section_' + nmb).slideDown()
  }
}

function addBtnBlock(e) {
  $('#inv_block_container_0').append(`<div id="dd-btn-container_${btnCount}" parent="0" data-delay="0" data-hover="false" class="cust-dd w-dropdown">
                    <div onclick="showBtnFields('${btnCount}')" class="cust-dd-tog sub-dd w-dropdown-toggle">
                      <div>Botón</div>
                      <div class="dd-icon w-icon-dropdown-toggle"></div>
                    </div>
                    <nav id="btn_section_${btnCount}" class="cust-dd-drawer w-dropdown-list">
                    <div class="flex ver small-gap">
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Texto en el botón</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Título"
                          id="inv-btn-title-${btnCount}"
                          required=""
                        >
                      </div>
                      <div class="cust-field-wrap">
                        <label for="field" class="field-label">Link del Botón (debe empezar con http o https)</label
                        ><input
                          type="text"
                          class="cust-input w-input"
                          maxlength="256"
                          name="title"
                          data-name="Field"
                          placeholder="Título"
                          id="inv-btn-link-${btnCount}"
                          required=""
                        >
                      </div>
                      <a href="#" onclick="deleteBtnDD(${btnCount})" class="cust-del w-inline-block"
                        ><img loading="lazy" src="//cdn.shopify.com/s/files/1/0665/4636/8751/t/3/assets/trash-01.svg?v=79518031219586732181678131632" alt="" class="icon">
                        <div style="color:#e73535">Eliminar Bloque</div>
                      </a>
                      </div>
                    </nav>
                  </div>`)
  if ($('#design_template').attr('data') == 'Template 1') {
    $('#btn-container').append(`<div id="invfooterbtnContainer-${btnCount}" class="cont">
                    <div class="inv-link-grid">
                      <a id="invfooterbtn-0-${btnCount}" target="_blank" href="" class="btn prod-btn w-button pc-btn"></a>
                    </div>
                  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 2') {
    $('#btn-container').append(`<div id="invfooterbtnContainer-${btnCount}" class="cont">
                    <div class="inv-link-grid">
                      <a id="invfooterbtn-0-${btnCount}" target="_blank" href="" class="btn prod-btn w-button sc-btn"></a>
                    </div>
                  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 3') {
    $('#btn-container').append(`<div id="invfooterbtnContainer-${btnCount}" class="cont">
                    <div class="inv-link-grid">
                      <a id="invfooterbtn-0-${btnCount}" target="_blank" href="" class="btn prod-btn w-button pc-underline-btn"></a>
                    </div>
                  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 4') {
    $('#btn-container').append(`<div id="invfooterbtnContainer-${btnCount}" class="cont">
                    <div class="inv-link-grid">
                      <a id="invfooterbtn-0-${btnCount}" target="_blank" href="" class="btn full-btn w-button pc-transparent-btn"></a>
                    </div>
                  </div>`)
  }
  if ($('#design_template').attr('data') == 'Template 5') {
    $('#btn-container').append(`<a id="invfooterbtn-0-${btnCount}" target="_blank" href="" class="btn prim-btn w-button tc-pc-btn"></a>`)
  }
  for (let i = 0; i < InvsectionsContent.length; i++) {
    for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
      if (InvsectionsContent[i].fields[j].key == "botones") {
        console.log(InvsectionsContent[i].fields[j].value)
        InvsectionsContent[i].fields[j].value.push('|')
        break
      }
    }
  }
  automatizeBtnText(btnCount)
  btnCount++
}

function automatizeBtnText(nmb) {
  document.getElementById('inv-btn-title-' + nmb).addEventListener('change', async (e) => {
    $('#invfooterbtn-0-' + nmb).text(e.target.value)
    console.log(e.target.value)
    for (let i = 0; i < InvsectionsContent.length; i++) {
      for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
        if (InvsectionsContent[i].fields[j].key == "botones") {
          var content = InvsectionsContent[i].fields[j].value[nmb]
          content = content.split('|')
          content[1] = e.target.value
          InvsectionsContent[i].fields[j].value[nmb] = content[0] + '|' + content[1]
          break
        }
      }
    }
  })
  document.getElementById('inv-btn-link-' + nmb).addEventListener('change', async (e) => {
    var val = e.target.value
    if (!e.target.value.includes('http')) {
      val = 'https://' + e.target.value
    }
    val = val.replaceAll(' ', '')
    if (val == 'https://') {
      val = ''
    }
    $('#invfooterbtn-0-' + nmb).attr('href', val)
    console.log(e.target.value)

    for (let i = 0; i < InvsectionsContent.length; i++) {
      for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
        if (InvsectionsContent[i].fields[j].key == "botones") {
          var content = InvsectionsContent[i].fields[j].value[nmb]
          content = content.split('|')
          content[0] = val
          InvsectionsContent[i].fields[j].value[nmb] = content[0] + '|' + content[1]
          break
        }
      }
    }
  })
}

function deleteBtnDD(nmb) {
  $('#dd-btn-container_' + nmb).remove()
  $('#invfooterbtn-0-' + nmb).remove()
  if ($('#invfooterbtnContainer-' + nmb)) {
    $('#invfooterbtnContainer-' + nmb).remove()
  }
  for (let i = 0; i < InvsectionsContent.length; i++) {
    for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
      if (InvsectionsContent[i].fields[j].key == "botones") {
        InvsectionsContent[i].fields[j].value[nmb] = ''
        break
      }
    }
  }
}

function hideSection(e, section, nmb) {
  console.log(e.innerText)
  console.log('entra a este')
  console.log(section)
  for (let i = 0; i < InvsectionsContent.length; i++) {
    if (InvsectionsContent[i].id == nmb) {
      console.log(InvsectionsContent[i])
      if (e.innerText.includes('Mostrar')) {
        e.innerText = "Esconder Sección"
        $('#' + section + '-' + nmb).removeClass('d-none')
        $('#' + section + '-' + nmb).slideDown()

        for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
          if (InvsectionsContent[i].fields[j].key == section + "_visible") {
            InvsectionsContent[i].fields[j].value = "true"
            break
          }
        }
      }
      else {
        e.innerText = "Mostrar Sección"
        $('#' + section + '-' + nmb).slideUp()
        for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
          if (InvsectionsContent[i].fields[j].key == section + "_visible") {
            InvsectionsContent[i].fields[j].value = "false"
            break
          }
        }
      }
    }
  }
  console.log(InvsectionsContent)
}

function selectEvent(event, father) {
  var events = JSON.parse($('#normalEvents' + father).attr('value'))
  var index = parseInt($('#invEvent-' + event + '-' + father).attr('eventid')) - 1
  var eventId = events[index]
  for (let i = 0; i < InvsectionsContent.length; i++) {
    if (InvsectionsContent[i].id == father) {
      for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
        if (InvsectionsContent[i].fields[j].key == "eventos") {
          if (InvsectionsContent[i].fields[j].value.includes(eventId)) {
            var eventName = $('#father' + father + 'Event' + event).text().split('Ocultar ')[1]
            InvsectionsContent[i].fields[j].value.splice(InvsectionsContent[i].fields[j].value.indexOf(eventId), 1);
            $('#father' + father + 'Event' + event).text('Mostrar ' + eventName)
            $('#invEvent-' + event + '-' + father).slideUp()
          }
          else {
            var eventName = $('#father' + father + 'Event' + event).text().split('Mostrar ')[1]
            InvsectionsContent[i].fields[j].value.push(eventId)
            $('#father' + father + 'Event' + event).text('Ocultar ' + eventName)
            $('#invEvent-' + event + '-' + father).slideDown()
          }
        }
      }
    }
  }
}

async function saveInvitation() {
  generalLoader.on()
  $('.loader-msg').text('Guardando cambios')
  for (let i = 0; i < InvsectionsContent.length; i++) {
    for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
      if (InvsectionsContent[i].fields[j].key == "botones") {
        console.log('content antes de')
        console.log(InvsectionsContent[i].fields[j].value)
        var content = InvsectionsContent[i].fields[j].value
        console.log('content')
        console.log(InvsectionsContent[i].fields[j].value)
        console.log(content)
        for (let k = 0; k < content.length; k++) {
          if (content[k] == '' || content[k] == '|') {
            console.log(content[k])
            content.splice(k, 1)
          }
        }
        InvsectionsContent[i].fields[j].value = JSON.stringify(content)
        break
      }
    }
  }
  var design_metafield = $('#design_metafield-2').attr('data')
  if ($('#font-selector-3').val() == null) {
    var tip1 = ''
  }
  else {
    var tip1 = $('#font-selector-3').val()
  }
  if ($('#font-selector-4').val() == null) {
    var tip2 = ''
  }
  else {
    var tip2 = $('#font-selector-4').val()
  }
  console.log('Aquí guarda el diseño')
  await updateMetaObject(design_metafield, [{ "key": "color_primario", "value": $('#color-primario1').val() }, { "key": "color_secundario", "value": $('#color-secundario1').val() }, { "key": "color_terciario", "value": $('#color-terciario1').val() }, { "key": "tipografia_principal", "value": tip1 }, { "key": "tipografia_de_apoyo", "value": tip2 }])
  var firstFile
  for (let i = 0; i < InvsectionsContent.length; i++) {
    var fileId
    var file
    if ($('#invitation-' + i)) {
      var element = document.querySelector('#invitation-' + i)
      await html2canvas(element).then(canvas => {
        // Convert the canvas to an image URL
        var imageUrl = canvas.toDataURL();

        // Create a link element to download the image
        var link = document.createElement('a');
        link.href = imageUrl;
        // Click the link to download the image
        document.body.appendChild(link);
        var base64Image2 = imageUrl.substring(imageUrl.indexOf(',') + 1);

        // Convierte el contenido base64 en un objeto Blob
        var blob = b64toBlob(base64Image2, 'image/png');

        // Crea un objeto File a partir del objeto Blob
        file = new File([blob], 'invitacion' + i + '.png', { type: 'image/png' });
        console.log(file)
      });
    }
    console.log('va a ')
    fileId = await getFileId(file)
    if (i == 0) {
      firstFile = fileId
    }
    if (fileId == undefined) {
      console.log('entra a asignar el file')
      fileId = firstFile
    }
    console.log('el file es ' + fileId)
    for (let j = 0; j < InvsectionsContent[i].fields.length; j++) {
      if (InvsectionsContent[i].fields[j].key == "imagen_de_invitacion") {
        console.log(InvsectionsContent[i].fields[j].value)
        InvsectionsContent[i].fields[j].value = fileId
      }
      if (InvsectionsContent[i].fields[j].key == "eventos") {
        var showEventMessage = false
        console.log('Eventos')
        console.log(InvsectionsContent[i].fields[j].value)
        InvsectionsContent[i].fields[j].value = []
        if (InvEventsContent.length == 0) {
          InvsectionsContent[i].fields[j].value = ""
        }
        else {
          for (let k = 0; k < InvEventsContent.length; k++) {
            var emptyFields = false
            for (let l = 0; l < InvEventsContent[k].fields.length; l++) {
              console.log(InvEventsContent[k].fields[l].value)
              if (InvEventsContent[k].fields[l].value == '' || InvEventsContent[k].fields[l].value == null) {
                if (InvEventsContent[k].fields[l].key != 'ubicacion') {
                  if (InvEventsContent[k].fields[l].key != "requiere_invitacion") {
                    emptyFields = true
                    showEventMessage = true
                  }
                }
              }
            }
            if (!emptyFields) {
              if (InvEventsContent[k].graphId != "") {
                console.log('Entra al update')
                await updateMetaObject(InvEventsContent[k].fields[5].value, InvEventsContent[k].ubicacion_fields)
                await updateMetaObject(InvEventsContent[k].graphId, InvEventsContent[k].fields)
                InvsectionsContent[i].fields[j].value.push(InvEventsContent[k].graphId)
              }
              else {
                var invUbication = await createGeneralMetaobject({ "type": "bloques_ubicaciones", "fields": InvEventsContent[k].ubicacion_fields })
                InvEventsContent[k].fields[5].value = invUbication
                InvsectionsContent[i].fields[j].value.push(await createGeneralMetaobject({ "type": "mesa_de_regalos_eventos", "fields": InvEventsContent[k].fields }))
              }
            }
          }
          InvsectionsContent[i].fields[j].value = JSON.stringify(InvsectionsContent[i].fields[j].value)
          console.log('Entra al addCollectionMetafield')
          await addCollectionMetafield(collectionId, { "namespace": "custom", "key": "eventos", "value": InvsectionsContent[i].fields[j].value, "type": "list.metaobject_reference" })
          console.log('Salio del addCollectionMetafield')
        }
      }
      if (InvsectionsContent[i].fields[j].key == "botones") {
        InvsectionsContent[i].fields[j].value = JSON.stringify(JSON.parse(InvsectionsContent[i].fields[j].value).filter(function (a) { return a !== '' }))
        if (JSON.parse(InvsectionsContent[i].fields[j].value).length == 0) {
          InvsectionsContent[i].fields[j].value = ""
        }
      }
      if (InvsectionsContent[i].fields[j].value == null) {
        InvsectionsContent[i].fields[j].value = ""
      }
    }
  }

  var sectionsIds = []
  var pageId = $('#InvpageId').attr('data')
  for (let i = 0; i < InvsectionsContent.length; i++) {
    console.log('sera aca?')
    sectionsIds.push(await createGeneralMetaobjectSanitized(InvsectionsContent[i]))
    const invId = sectionsIds[i].replace('gid://shopify/Metaobject/', '')
    const link_to_inv = getCleanURL({ invitacion: invId })
    await updateMetaObject(sectionsIds[i], [{ "key": "link_de_la_invitacion", "value": link_to_inv }])
  }
  var page_metafield = JSON.parse($('#pageInvMetafield').text())
  console.log('Entra al addPageMetafield')
  await addPageMetafield(pageId, { "namespace": "custom", "key": "wedsite_invitaciones", "type": "list.metaobject_reference", "value": JSON.stringify(sectionsIds) })
  console.log('Salio del addPageMetafield')
  for (let i = 0; i < page_metafield.length; i++) {
    await deletelMetaobject(page_metafield[i])
  }
  if (showEventMessage) {
    $('.loader-msg').text('Algunos eventos no se guardaron debido a que no se rellenaron todos los campos')
  }
  $('.loader-msg').text('Los cambios se guardaron correctamente, espera un momento mientras se recarga la página')
  setTimeout(() => {
    generalLoader.off()
    location.reload()
  }, 5000)
}

async function downloadPDF(id, url) {
  // Opción 1: Usar window.print() - Respeta todos los estilos CSS perfectamente
  // El usuario puede "Guardar como PDF" desde el diálogo de impresión
  
  generalLoader.on()
  $('.loader-msg').text('Preparando vista de impresión...')
  
  const invitation = document.getElementById('inv')
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  // Crear estilos específicos para impresión
  const printStyle = document.createElement('style')
  printStyle.id = 'print-styles'
  printStyle.textContent = `
    @media print {
      body * {
        visibility: hidden;
      }
      #inv, #inv * {
        visibility: visible;
      }
      #inv {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        box-shadow: none !important;
      }
      /* Asegurar que los botones se vean correctamente */
      .btn, a.btn, .w-button {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        page-break-inside: avoid !important;
      }
      /* Evitar saltos de página dentro de secciones */
      .inv-sec {
        page-break-inside: avoid !important;
      }
      /* Mantener colores en impresión */
      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
    }
  `
  document.head.appendChild(printStyle)
  
  setTimeout(() => {
    generalLoader.off()
    
    // Abrir diálogo de impresión
    window.print()
    
    // Limpiar estilos después de imprimir/cancelar
    setTimeout(() => {
      const styleEl = document.getElementById('print-styles')
      if (styleEl) styleEl.remove()
    }, 1000)
  }, 500)
}

// Función auxiliar para copiar TODOS los estilos computados como inline
function copyComputedStyles(source, target) {
  const computedStyle = window.getComputedStyle(source)
  
  // Lista exhaustiva de propiedades CSS que debemos copiar
  const criticalStyles = [
    // Colores y fondos
    'background-color', 'background-image', 'background-size', 'background-position',
    'background-repeat', 'background-attachment', 'background-clip', 'background-origin',
    'color', 'opacity',
    
    // Tipografía
    'font-family', 'font-size', 'font-weight', 'font-style', 'font-variant',
    'line-height', 'letter-spacing', 'word-spacing', 'text-align', 'text-decoration',
    'text-transform', 'text-indent', 'white-space', 'word-wrap', 'word-break',
    
    // Box model
    'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
    'border', 'border-width', 'border-style', 'border-color', 'border-radius',
    'border-top', 'border-right', 'border-bottom', 'border-left',
    
    // Dimensiones
    'width', 'height', 'max-width', 'max-height', 'min-width', 'min-height',
    'box-sizing',
    
    // Posicionamiento
    'position', 'top', 'left', 'right', 'bottom', 'z-index',
    
    // Flexbox
    'display', 'flex-direction', 'justify-content', 'align-items', 'align-content',
    'flex-wrap', 'flex', 'flex-grow', 'flex-shrink', 'flex-basis', 'order',
    'align-self',
    
    // Grid (por si acaso)
    'grid-template-columns', 'grid-template-rows', 'grid-gap', 'grid-column-gap',
    'grid-row-gap',
    
    // Otros
    'overflow', 'overflow-x', 'overflow-y', 'visibility', 'cursor',
    'transform', 'transform-origin', 'box-shadow', 'text-shadow'
  ]
  
  // Copiar cada propiedad como inline style
  criticalStyles.forEach(prop => {
    const value = computedStyle.getPropertyValue(prop)
    if (value && value !== 'none' && value !== 'auto' && value !== 'normal') {
      target.style.setProperty(prop, value, 'important')
    }
  })
  
  // CRÍTICO: Forzar que transition sea none para evitar animaciones durante captura
  target.style.setProperty('transition', 'none', 'important')
  target.style.setProperty('animation', 'none', 'important')
}

// Función recursiva para aplicar estilos a todos los elementos
function applyStylesToClone(original, clone) {
  copyComputedStyles(original, clone)
  
  const originalChildren = original.children
  const cloneChildren = clone.children
  
  for (let i = 0; i < originalChildren.length; i++) {
    if (cloneChildren[i]) {
      applyStylesToClone(originalChildren[i], cloneChildren[i])
    }
  }
}

// Nueva función alternativa usando html2canvas mejorado
async function downloadPDFCanvas(id, url) {
  // Configuración de ajuste de padding para botones en PDF
  // html2canvas no renderiza correctamente padding-bottom en elementos inline-block
  // Estos valores compensan la diferencia entre renderizado web y canvas
  const PDF_BUTTON_PADDING_TOP = 5.5  // px - padding superior del botón en PDF
  const PDF_BUTTON_PADDING_BOTTOM = 15  // px - padding inferior del botón en PDF
  
  generalLoader.on()
  $('.loader-msg').text('Creando PDF')
  const invitation = document.getElementById('inv')
  
  if (!invitation) {
    generalLoader.off()
    $('.loader-msg').text('Error: No se encontró el elemento de invitación')
    return
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  // Esperar a que fuentes y estilos se carguen completamente
  await new Promise(resolve => {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(resolve)
    } else {
      setTimeout(resolve, 800)
    }
  })

  // Recolectar información de los botones/enlaces para hacerlos clickeables
  const buttons = []
  
  invitation.querySelectorAll('a[href], button, .btn').forEach(element => {
    const href = element.getAttribute('href') || element.getAttribute('data-url')
    
    if (href && href !== '#' && !href.startsWith('javascript:')) {
      const rect = element.getBoundingClientRect()
      const invRect = invitation.getBoundingClientRect()
      
      buttons.push({
        url: href,
        x: Math.max(0, rect.left - invRect.left),
        y: Math.max(0, rect.top - invRect.top),
        width: rect.width,
        height: rect.height
      })
    }
  })

  const height = invitation.offsetHeight
  const width = invitation.offsetWidth

  setTimeout(async () => {
    try {
      const canvas = await html2canvas(invitation, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: null,
        imageTimeout: 0,
        width: width,
        height: height,
        windowWidth: width,
        windowHeight: height,
        onclone: (clonedDoc) => {
          const clonedInv = clonedDoc.getElementById('inv')
          if (clonedInv) {
            // Aplicar estilos computados recursivamente a todos los elementos
            applyStylesToClone(invitation, clonedInv)
            
            // Tratamiento especial para botones
            clonedInv.querySelectorAll('.btn, a.btn, button, .w-button, [class*="btn"]').forEach((btn, index) => {
              const originalBtn = invitation.querySelectorAll('.btn, a.btn, button, .w-button, [class*="btn"]')[index]
              if (originalBtn) {
                const styles = window.getComputedStyle(originalBtn)
                
                // Colores
                btn.style.setProperty('background-color', styles.backgroundColor, 'important')
                btn.style.setProperty('color', styles.color, 'important')
                
                // Tipografía
                btn.style.setProperty('font-family', styles.fontFamily, 'important')
                btn.style.setProperty('font-size', styles.fontSize, 'important')
                btn.style.setProperty('font-weight', styles.fontWeight, 'important')
                btn.style.setProperty('font-style', styles.fontStyle, 'important')
                btn.style.setProperty('text-decoration', styles.textDecoration, 'important')
                btn.style.setProperty('text-transform', styles.textTransform, 'important')
                
                // Bordes
                btn.style.setProperty('border', styles.border, 'important')
                btn.style.setProperty('border-radius', styles.borderRadius, 'important')
                
                // Obtener padding lateral original
                const paddingLeft = parseFloat(styles.paddingLeft) >= 0 ? parseFloat(styles.paddingLeft) : 20
                const paddingRight = parseFloat(styles.paddingRight) >= 0 ? parseFloat(styles.paddingRight) : 20
                
                // Aplicar configuración de padding ajustada para PDF
                btn.style.setProperty('display', 'inline-block', 'important')
                btn.style.setProperty('padding-top', PDF_BUTTON_PADDING_TOP + 'px', 'important')
                btn.style.setProperty('padding-bottom', PDF_BUTTON_PADDING_BOTTOM + 'px', 'important')
                btn.style.setProperty('padding-left', paddingLeft + 'px', 'important')
                btn.style.setProperty('padding-right', paddingRight + 'px', 'important')
                btn.style.setProperty('height', 'auto', 'important')
                btn.style.setProperty('box-sizing', 'border-box', 'important')
                btn.style.setProperty('text-align', 'center', 'important')
                btn.style.setProperty('vertical-align', 'middle', 'important')
                btn.style.setProperty('line-height', '1', 'important')
                
                if (styles.width && styles.width !== 'auto') {
                  btn.style.setProperty('width', styles.width, 'important')
                }
                
                btn.style.setProperty('transition', 'none', 'important')
                btn.style.setProperty('animation', 'none', 'important')
                btn.style.setProperty('position', 'static', 'important')
              }
            })
            
            // Tratamiento especial para contenedores flex y grid
            clonedInv.querySelectorAll('.flex, [class*="grid"]').forEach((container, index) => {
              const originalContainer = invitation.querySelectorAll('.flex, [class*="grid"]')[index]
              if (originalContainer) {
                const styles = window.getComputedStyle(originalContainer)
                
                if (styles.display.includes('grid')) {
                  container.style.setProperty('display', 'flex', 'important')
                  container.style.setProperty('flex-wrap', 'wrap', 'important')
                  container.style.setProperty('gap', styles.gridGap || styles.gap || '0px', 'important')
                }
                
                for (let i = 0; i < styles.length; i++) {
                  const prop = styles[i]
                  const value = styles.getPropertyValue(prop)
                  if (value) {
                    container.style.setProperty(prop, value, 'important')
                  }
                }
              }
            })
            
            // Forzar colores de fondo en todas las secciones
            clonedInv.querySelectorAll('[class*="-bg"], [class*="-sec"], .inv-sec').forEach((sec, index) => {
              const originalSec = invitation.querySelectorAll('[class*="-bg"], [class*="-sec"], .inv-sec')[index]
              if (originalSec) {
                const styles = window.getComputedStyle(originalSec)
                sec.style.setProperty('background-color', styles.backgroundColor, 'important')
                sec.style.setProperty('color', styles.color, 'important')
              }
            })
          }
        }
      })

      // Crear PDF con las dimensiones exactas del contenido
      const imgData = canvas.toDataURL('image/png', 1.0)
      
      const mmWidth = (width * 25.4) / 96
      const mmHeight = (height * 25.4) / 96
      
      const pdf = new jsPDF({
        unit: 'mm',
        format: [mmWidth, mmHeight],
        orientation: mmHeight > mmWidth ? 'portrait' : 'landscape',
        compress: true
      })

      pdf.addImage(imgData, 'PNG', 0, 0, mmWidth, mmHeight, undefined, 'FAST')
      
      // Agregar enlaces clickeables
      buttons.forEach(btn => {
        if (btn.width > 0 && btn.height > 0) {
          try {
            const btnX = (btn.x * 25.4) / 96
            const btnY = (btn.y * 25.4) / 96
            const btnWidth = (btn.width * 25.4) / 96
            const btnHeight = (btn.height * 25.4) / 96
            
            pdf.link(btnX, btnY, btnWidth, btnHeight, { url: btn.url })
          } catch (e) {
            console.warn('No se pudo agregar enlace:', e)
          }
        }
      })

      pdf.save('invitacion.pdf')
      $('.loader-msg').text('PDF descargado correctamente')
    } catch (error) {
      console.error('Error al generar PDF:', error)
      $('.loader-msg').text('Error al generar el PDF: ' + error.message)
    } finally {
      setTimeout(() => {
        generalLoader.off()
      }, 500)
    }
  }, 1000);
}
function getCleanURL(newParams = {}) {
  let url = new URL(window.location.href);
  url.search = "";
  let baseURL = url.origin;
  let shopifyShop = Shopify?.shop; // Shopify inyecta una variable global "Shopify"

  if (shopifyShop) {
    baseURL = `https://${shopifyShop}`;
  }

  let cleanURL = `${baseURL}${url.pathname}`;

  let newSearchParams = new URLSearchParams(newParams).toString();
  if (newSearchParams) {
    cleanURL += `?${newSearchParams}`;
  }
  return cleanURL;
}

